import React from 'react';
import { useParams } from 'react-router-dom';
import PublicSurveyPage from './PublicSurveyPage';

// Kişi-bazlı davet token'ıyla anket doldurma sayfası (/survey/davet/:token).
// PublicSurveyPage'i token modunda yeniden kullanır: davet endpoint'lerinden
// yükler/gönderir, kişi bilgilerini davetten önceden doldurur.
export default function PublicSurveyInvitePage() {
  const { token } = useParams<{ token: string }>();
  return <PublicSurveyPage inviteToken={token} />;
}
